// src/utils/importApi.ts
// 外部サービスからのデータインポートAPI（rl-api-14-import, api.readlinker.com/import）

import axios from 'axios';
import { NEW_API } from '../config/api';

function authHeaders(idToken: string) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}

export interface ImportFailedItem {
  isbn13: string;
  title: string;
  author: string;
  publisher: string;
  reason: string;
  category: string;
  registered_at: string;
  memo: string;
  review: string;
}

export interface ImportResult {
  total_rows: number;
  imported: number;
  skipped_duplicate: number;
  failed_count: number;
  failed: ImportFailedItem[];
  shelves_created: string[];
  highlights_created: number;
}

export interface ImportResolveResult {
  imported: number;
  skipped_duplicate: number;
  shelves_created: string[];
  highlights_created: number;
}

export interface ResolveItem {
  rl_book_id: number;
  category: string;
  registered_at: string;
  memo: string;
  review: string;
}

/** File を base64 文字列に変換する（Shift-JIS等の生バイトをそのまま保持するため、テキストとしては読まない） */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // "data:*/*;base64,xxxx" の "xxxx" 部分だけを取り出す
      const base64 = result.split(',')[1] ?? '';
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

/** POST /import operation_type=import_booklog */
export async function importBooklogCsv(csvBase64: string, idToken: string): Promise<ImportResult> {
  const res = await axios.post(
    NEW_API.IMPORT,
    { operation_type: 'import_booklog', csv_base64: csvBase64 },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as ImportResult;
}

/** POST /import operation_type=import_booklog_resolve（ISBN未解決だった行を手動選択したrl_book_idで登録） */
export async function importBooklogResolve(items: ResolveItem[], idToken: string): Promise<ImportResolveResult> {
  const res = await axios.post(
    NEW_API.IMPORT,
    { operation_type: 'import_booklog_resolve', items },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as ImportResolveResult;
}

/** POST /import operation_type=import_readee */
export async function importReadeeCsv(csvBase64: string, idToken: string): Promise<ImportResult> {
  const res = await axios.post(
    NEW_API.IMPORT,
    { operation_type: 'import_readee', csv_base64: csvBase64 },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as ImportResult;
}

/** POST /import operation_type=import_readee_resolve（ISBN未解決だった行を手動選択したrl_book_idで登録） */
export async function importReadeeResolve(items: ResolveItem[], idToken: string): Promise<ImportResolveResult> {
  const res = await axios.post(
    NEW_API.IMPORT,
    { operation_type: 'import_readee_resolve', items },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as ImportResolveResult;
}
